import { render, staticRenderFns } from "./StatusIndicator.vue?vue&type=template&id=4845b253&scoped=true"
import script from "./StatusIndicator.vue?vue&type=script&lang=js"
export * from "./StatusIndicator.vue?vue&type=script&lang=js"
import style0 from "./StatusIndicator.vue?vue&type=style&index=0&id=4845b253&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4845b253",
  null
  
)

export default component.exports